/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  DatePicker,
  Alert,
} from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import percentFormatter from 'utils/percentFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import PercentageInput from 'components/PercentageInput';
import ModalDelete from 'components/ModalDelete';
import NumericInput from 'components/NumericInput';
import CurrencyInput from 'components/CurrencyInput';
import ModalConfirmation from 'components/ModalConfirmation';
import {
  FLOAT_NUMER_PATTERN,
  integerRegExp,
  SLUG_PATTERN,
} from 'utils/patterns';
import Select from 'components/Select';
import { getEstadosGlobales, getPeriodicidadesDePagos } from 'api/catalogos/index';
import {
  getPercepcionesConfiguracionesISR,
  postPercepcionConfiguracionISR,
  deletePercepcionConfiguracionISR,
  patchPercepcionConfiguracionISR,
  getPercepcionConfiguracionISR,
} from 'api/nominas/percepciones/percepcionesConfiguracionesISR';
import {
  getPercepciones,
} from 'api/nominas/percepciones/percepciones';
import {
  getPercepcionesTiposISR,
} from 'api/nominas/percepciones/percepcionesTiposISR';
import {
  getAplicacionesContribuciones,
} from 'api/nominas/catalogos/aplicacionesContribuciones';
import { checkToken } from 'api/utils';
import {
  CONTRIBUCION_EXCENTO,
  CONTRIBUCION_GRAVADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_CANCELADO,
  CONTRIBUCION_PARCIALMENTE,
  CONTRIBUCION_NO_APLICA,
} from 'utils/constants';
import TextArea from 'antd/lib/input/TextArea';

export const percepcionConfiguracionISRPermission = {
  permissionModel: 'percepcionconfiguracionisr',
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/percepciones-configuraciones-isr';

const PercepcionConfiguracionISR = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [tiposISR, setTiposISR] = useState([]);
  const [estados, setEstados] = useState([]);
  const [percepciones, setPercepciones] = useState([]);
  const [aplicaciones, setAplicaciones] = useState([]);
  const [aplicaImporte, setAplicaImporte] = useState(false);
  const [aplicaPorcentaje, setAplicaPorcentaje] = useState(false);
  const [aplicaLimite, setAplicaLimite] = useState(false);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [aplicaUMAExcento, setAplicaUMAExcento] = useState(false);
  const [aplicacionISR, setAplicacionISR] = useState(false);
  const [percepcionesFiltered, setPercepcionesFiltered] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [confirmationVisibleCancelar, setConfirmationVisibleCancelar] = useState(false);
  const [confirmationVisibleReactivar, setConfirmationVisibleReactivar] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estatusCancelado, setEstatusCancelado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [aplicaFundamento, setAplicaFundamento] = useState(false);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        percepcion_concepto: e?.percepcion,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const formInstances = [
    form,
  ];

  const onChangeAplicacion = (val) => {
    if (val === CONTRIBUCION_PARCIALMENTE) {
      setAplicacionISR(false);
    } else {
      setAplicacionISR(true);
      form.setFieldsValue({
        aplica_no_umas_excento: false,
        no_umas_excento: 0,
        aplica_importe_excento: false,
        importe_excento: 0,
        aplica_porcentaje_excento: false,
        porcentaje_excento: 0,
        aplica_limite_de_excencion: false,
        no_umas_limite_de_excencion: 0,
        periodicidad_de_pago: null,
      });
      setAplicaImporte(form.getFieldValue('aplica_importe_excento'));
      setAplicaPorcentaje(form.getFieldValue('aplica_porcentaje_excento'));
      setAplicaLimite(form.getFieldValue('aplica_limite_de_excencion'));
      setAplicaUMAExcento(form.getFieldValue('aplica_no_umas_excento'));
      setAplicaFundamento(val === CONTRIBUCION_NO_APLICA);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPercepcionesConfiguracionesISR();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tipos,
        _percepciones,
        _aplicaciones,
        _periodicidades,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPercepcionesTiposISR(),
        getPercepciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getAplicacionesContribuciones(),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getPercepcionesConfiguracionesISR(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposISR(_tipos);
        setPercepciones(_percepciones);
        setAplicaciones(_aplicaciones);
        setPeriodicidades(_periodicidades);
        setPercepcionesFiltered(
          percepciones.filter((e) => !data.some((val) => val?.percepcion === e.id
            && (val?.estados_globales === ESTATUS_ACTIVO || val?.estados_globales === ESTATUS_AUTORIZADO))),
        );
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();

    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setSelectedRowData();
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setEstatusCancelado(false);
    setPercepcionesFiltered(
      percepciones.filter((e) => !data.some((val) => val?.percepcion === e.id
        && (val?.estados_globales === ESTATUS_ACTIVO || val?.estados_globales === ESTATUS_AUTORIZADO))),
    );
    setVisible(false);
    form.resetFields();
    setAplicaImporte(false);
    setAplicaPorcentaje(false);
    setAplicaLimite(false);
    setAplicaUMAExcento(false);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _percepcion = await getPercepcionConfiguracionISR(match.id);
    if (_percepcion?.estados_globales === ESTATUS_ACTIVO
      || _percepcion?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (_percepcion?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_percepcion?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    if (_percepcion?.estados_globales === ESTATUS_CANCELADO) {
      setEstadosFiltered(estados?.filter((estado) => estado?.id === ESTATUS_CANCELADO));
      setEstatusCancelado(true);
    }
    setTimeout(() => {
      if (_percepcion) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedClone(_percepcion));
          setVisible(true);
          setAplicaImporte(form.getFieldValue('aplica_importe_excento'));
          setAplicaPorcentaje(form.getFieldValue('aplica_porcentaje_excento'));
          setAplicaLimite(form.getFieldValue('aplica_limite_de_excencion'));
          setAplicaUMAExcento(form.getFieldValue('aplica_no_umas_excento'));
          setPercepcionesFiltered(
            percepciones.filter((e) => !data.some((val) => {
              if (val.percepcion === _percepcion.percepcion) {
                return false;
              }
              return val.percepcion === e.id;
            })),
          );
        });
      }
    });
    setLoading(false);
    const campo_aplicacion = form.getFieldValue('aplicacion_contribucion');
    onChangeAplicacion(campo_aplicacion);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchPercepcionConfiguracionISR(key, values) : postPercepcionConfiguracionISR(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePercepcionConfiguracionISR(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedRowData(record);
    setEstatusCancelado(record.estados_globales === ESTATUS_CANCELADO);
    setEstatusAutorizado(record.estados_globales === ESTATUS_AUTORIZADO);
    setEstatusInactivo(record.estados_globales === ESTATUS_INACTIVO);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const contentModalDelete = (val) => percepciones.find((e) => e.id === val)?.clave;

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchPercepcionConfiguracionISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setEstatusAutorizado(true);
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede cancelar una nómina ya cancelada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_CANCELADO,
      };
      const res = await patchPercepcionConfiguracionISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setEstatusCancelado(true);
        setEstatusAutorizado(false);
        setConfirmationVisibleCancelar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_ACTIVO,
      };
      const res = await patchPercepcionConfiguracionISR(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setEstatusCancelado(false);
        setEstatusAutorizado(false);
        setConfirmationVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      titleText: 'Clave Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 200,
      render: (val) => percepciones.find((e) => e.id === val)?.clave,
    },
    {
      titleText: 'Concepto de Percepción',
      dataIndex: 'percepcion_concepto',
      key: 'percepcion_concepto',
      width: 300,
      render: (val) => percepciones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fundamento ISR',
      dataIndex: 'fundamento',
      key: 'fundamento',
      width: 200,
    },
    {
      titleText: 'Aplicación ISR',
      dataIndex: 'aplicacion_contribucion',
      key: 'aplicacion_contribucion',
      width: 200,
      render: (val) => aplicaciones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'No. de UMA Exentos',
      dataIndex: 'no_umas_excento',
      key: 'no_umas_excento',
      width: 200,
    },
    {
      titleText: 'Importe Exento',
      dataIndex: 'importe_excento',
      key: 'importe_excento',
      width: 200,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: '% de Exención',
      dataIndex: 'porcentaje_excento',
      key: 'porcentaje_excento',
      width: 200,
      align: 'right',
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'UMA Límite de Exención',
      dataIndex: 'no_umas_limite_de_excencion',
      key: 'no_umas_limite_de_excencion',
      width: 250,
    },
    {
      titleText: 'Periodicidad de Aplicación de la Exención',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      width: 300,
      render: (val) => periodicidades.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Tipo de Percepción',
      dataIndex: 'percepcion_tipo',
      key: 'percepcion_tipo',
      width: 200,
      render: (val) => tiposISR.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    descripcion: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    dias: [
      requiredRule,
      {
        pattern: integerRegExp,
        message: 'Ingrese un valor válido',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    porcentaje: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async () => {
          const { porcentaje_excento } = form.getFieldValue();
          if (porcentaje_excento > 100) {
            throw new Error('Este campo no puede ser mayor a 100%');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="ISR Percepciones"
            rowSelection={rowSelection}
            allowExportPDF={false}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={estatusAutorizado}
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'percepcionconfiguracionisr', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length || estatusAutorizado || estatusInactivo
                  || selectedRowData?.estados_globales === ESTATUS_AUTORIZADO || selectedRowData?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                permission: { model: 'percepcionconfiguracionisr', action: 'cancelar' },
                onClick: () => setConfirmationVisibleCancelar(true),
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length || selectedRowData?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                permission: { model: 'percepcionconfiguracionisr', action: 'reactivar' },
                onClick: () => setConfirmationVisibleReactivar(true),
                text: 'Reactivar',
                icon: <ReloadOutlined />,
                disabledBySelection: false,
                className: 'warning',
                disabled: !selectedRowKeys?.length || selectedRowData?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            allowImport
            baseURI={baseURI}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepción Configuración para ISR`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Card
                type="inner"
                size="small"
                className="inner-block-card"
                title="1. Identificación De La Percepción"
                extra="Concepto, Tipo Y Aplicación Base"
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="percepcion"
                      label="Concepto de Percepción"
                      rules={rules.contratacion}
                      hasFeedback
                    >
                      <Select
                        keyLabelRender
                        dataSource={percepcionesFiltered}
                        disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="percepcion_tipo"
                      label="Tipo de Percepción para ISR"
                      rules={!aplicaFundamento ? rules.contratacion : false}
                      hasFeedback
                    >
                      <Select
                        dataSource={tiposISR}
                        disabled={aplicaFundamento || estatusAutorizado || estatusInactivo || estatusCancelado}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplicacion_contribucion"
                      label="Aplicación para ISR"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        dataSource={aplicaciones}
                        onChange={onChangeAplicacion}
                        disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      name="fundamento"
                      label="Fundamento de ISR"
                      hasFeedback
                    >
                      <Input
                        allowClear
                        disabled={estatusAutorizado || estatusInactivo || estatusCancelado || aplicaFundamento}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Card
                type="inner"
                size="small"
                className="inner-block-card"
                title="2. Configuración De Exención"
                extra="UMA, Importe Fijo O Porcentaje"
              >
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 15 }}
                  message="Solo uno de los tres métodos de exención debe estar activo a la vez: UMA exento, Importe exento fijo o Porcentaje de exención. Activar más de uno puede generar cálculos incorrectos."
                />
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="aplica_no_umas_excento"
                      label="Aplica Número de UMA Exento"
                      rules={rules.required}
                      initialValue={false}
                      hasFeedback
                    >
                      <Select
                        trueFalse
                        disabled={aplicacionISR || estatusAutorizado || estatusInactivo || estatusCancelado}
                        onChange={(value) => {
                          setAplicaUMAExcento(value);
                          form.resetFields(['no_umas_excento']);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <NumericInput
                      name="no_umas_excento"
                      label="Número de UMA Exento"
                      rules={aplicaUMAExcento ? rules.valor : null}
                      disabled={!aplicaUMAExcento || estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="aplica_importe_excento"
                      rules={!aplicacionISR ? rules.required : false}
                      label="Aplica Importe Exento"
                      initialValue={false}
                      hasFeedback
                    >
                      <Select
                        trueFalse
                        disabled={aplicacionISR || estatusAutorizado || estatusInactivo || estatusCancelado}
                        onChange={(value) => {
                          setAplicaImporte(value);
                          form.resetFields(['importe_excento']);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <CurrencyInput
                      name="importe_excento"
                      label="Importe Exento"
                      rules={aplicaImporte ? rules.valor : null}
                      disabled={!aplicaImporte || estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="aplica_porcentaje_excento"
                      rules={!aplicacionISR ? rules.required : false}
                      label="Aplica Porcentaje de Exención"
                      initialValue={false}
                      hasFeedback
                    >
                      <Select
                        disabled={aplicacionISR || estatusAutorizado || estatusInactivo || estatusCancelado}
                        trueFalse
                        onChange={(value) => {
                          setAplicaPorcentaje(value);
                          form.resetFields(['porcentaje_excento']);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <PercentageInput
                      name="porcentaje_excento"
                      label="Porcentaje de Exención"
                      rules={aplicaPorcentaje ? rules.porcentaje : null}
                      disabled={!aplicaPorcentaje || estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Col>
                </Row>
              </Card>
              <Card
                type="inner"
                size="small"
                className="inner-block-card"
                title="3. Límite De La Exención"
                extra="Tope Máximo Aplicable"
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_limite_de_excencion"
                      rules={!aplicacionISR ? rules.required : false}
                      label="Tiene Límite la Exención"
                      initialValue={false}
                      hasFeedback
                    >
                      <Select
                        disabled={aplicacionISR || estatusAutorizado || estatusInactivo || estatusCancelado}
                        trueFalse
                        onChange={(value) => {
                          setAplicaLimite(value);
                          form.resetFields(['no_umas_limite_de_excencion']);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <NumericInput
                      name="no_umas_limite_de_excencion"
                      label="Número de UMA Límite"
                      rules={aplicaLimite ? rules.dias : null}
                      disabled={!aplicaLimite || estatusAutorizado || estatusInactivo || estatusCancelado}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="periodicidad_de_pago"
                      label="Periodicidad de Aplicación de la Exención"
                      rules={!aplicacionISR ? rules.required : false}
                      hasFeedback
                    >
                      <Select
                        disabled={aplicacionISR || estatusAutorizado || estatusInactivo || estatusCancelado}
                        dataSource={periodicidades}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Card
                type="inner"
                size="small"
                className="inner-block-card"
                title="4. Control Y Vigencia"
                extra="Estatus Y Fecha De Vencimiento"
              >
                <Row gutter={10}>
                  {selectedRowKeys.length
                    ? (
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          rules={rules.estatus}
                          hasFeedback
                        >
                          <Select
                            dataSource={estadosFiltered}
                            disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                            onChange={(val) => {
                              if (val === ESTATUS_INACTIVO) {
                                setConfirmationVisibleEstatus(true);
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                    )
                    : (
                      <Col xs={24} sm={24} md={12}>
                        <Form.Item
                          name="estados_globales"
                          label="Estatus"
                          rules={rules.estatus}
                          hasFeedback
                          initialValue={1}
                        >
                          <Select
                            dataSource={estados}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    )}
                  <Col xs={24} sm={24} md={12}>
                    <Form.Item
                      name="vigente_al"
                      label="Vigente Al"
                      hasFeedback
                    >
                      <DatePicker
                        allowClear
                        format="DD/MM/YYYY"
                        disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      name="observaciones"
                      label="Observaciones"
                      hasFeedback
                    >
                      <TextArea
                        allowClear
                        rows={3}
                        disabled={estatusAutorizado || estatusInactivo || estatusCancelado}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Percepción Configuración ISR ${contentModalDelete(form.getFieldValue('percepcion'))}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar la Percepción Configuración ISR ${contentModalDelete(form.getFieldValue('percepcion'))}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationCancelar}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleCancelar(false);
          }}
          open={confirmationVisibleCancelar}
          title="Confirmación"
          contentTitle={`Cancelar la Percepción Configuración ISR ${contentModalDelete(form.getFieldValue('percepcion'))}?`}
          ConfirmAutorize
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationReactivar}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleReactivar(false);
          }}
          open={confirmationVisibleReactivar}
          title="Confirmación"
          contentTitle={`Reactivar la Percepción Configuración ISR ${contentModalDelete(form.getFieldValue('percepcion'))}?`}
          ConfirmAutorize
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar la Percepción Configuración ISR ${contentModalDelete(form.getFieldValue('percepcion'))}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default PercepcionConfiguracionISR;
